import * as React from 'react';
import { CheckIcon, Minus } from '../../icons';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';

import { cn } from '../../lib/utils';

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer size-4 shrink-0 rounded-[4px] border border-input shadow-xs transition-shadow outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-(--brand-500) data-[state=checked]:bg-(--brand-500) data-[state=checked]:text-white data-[state=indeterminate]:border-(--brand-500) data-[state=indeterminate]:bg-(--brand-500) data-[state=indeterminate]:text-white dark:bg-input/30 dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-(--brand-500) dark:data-[state=indeterminate]:bg-(--brand-500)",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        {props.checked === 'indeterminate' ? (
          <Minus data-icon="minus" weight="bold" className="size-3.5" />
        ) : (
          <CheckIcon data-icon="check" className="size-3.5" />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
